/**
 * Device Trust Token System
 * Manages trusted device identification
 */

const TRUST_TOKEN_KEY = 'babelmix_device_trust_token';
const TRUST_EXPIRY_DAYS = 30;

export const DeviceTrust = {
  // Generate simple 6-character token
  generateToken: () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Excluding similar chars (I, O, 1, 0)
    let token = '';
    for (let i = 0; i < 6; i++) {
      token += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return token;
  },

  getToken: () => {
    try {
      const data = localStorage.getItem(TRUST_TOKEN_KEY);
      if (!data) return null;
      
      const { token, expiry } = JSON.parse(data);
      if (new Date(expiry) < new Date()) {
        localStorage.removeItem(TRUST_TOKEN_KEY);
        return null;
      }
      return token;
    } catch {
      return null;
    }
  },
  
  setToken: (token) => {
    const expiry = new Date();
    expiry.setDate(expiry.getDate() + TRUST_EXPIRY_DAYS);
    localStorage.setItem(TRUST_TOKEN_KEY, JSON.stringify({ token, expiry: expiry.toISOString() }));
  },
  
  clearToken: () => {
    localStorage.removeItem(TRUST_TOKEN_KEY);
    localStorage.removeItem('device_token');
    console.log('🔐 Device token cleared');
  },
  
  // Get or create device token
  getDeviceToken: () => {
    let token = localStorage.getItem('device_token');
    if (!token) {
      token = DeviceTrust.generateToken();
      localStorage.setItem('device_token', token);
      console.log('🔐 New device token generated:', token);
    }
    return token;
  },
  
  // Get device info for backend
  getDeviceInfo: () => {
    const token = DeviceTrust.getDeviceToken();
    const userAgent = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    
    return {
      device_token: token,
      device_type: isMobile ? 'mobile' : 'desktop',
      device_name: isMobile ? 'Mobile Device' : 'Desktop/Laptop',
      user_agent: userAgent.substring(0, 200) // Limit length
    };
  }
};

/**
 * Browser-ID generieren (persistent pro Browser/Gerät)
 */
export const getBrowserId = () => {
  let browserId = localStorage.getItem('babelmix_browser_id');
  if (!browserId) {
    browserId = 'browser_' + Math.random().toString(36).substring(2, 15) + 
                Math.random().toString(36).substring(2, 15);
    localStorage.setItem('babelmix_browser_id', browserId);
  }
  return browserId;
};

/**
 * Browser-Info sammeln
 */
export const getBrowserInfo = () => {
  const ua = navigator.userAgent;
  let browserName = 'Unknown';
  let osName = 'Unknown';
  
  // Browser detection
  if (ua.includes('Firefox')) browserName = 'Firefox';
  else if (ua.includes('SamsungBrowser')) browserName = 'Samsung Internet';
  else if (ua.includes('Opera') || ua.includes('OPR')) browserName = 'Opera';
  else if (ua.includes('Edg')) browserName = 'Edge';
  else if (ua.includes('Chrome')) browserName = 'Chrome';
  else if (ua.includes('Safari')) browserName = 'Safari';
  
  // OS detection
  if (ua.includes('Windows')) osName = 'Windows';
  else if (ua.includes('Mac OS')) osName = 'macOS';
  else if (ua.includes('Linux')) osName = 'Linux';
  else if (ua.includes('Android')) osName = 'Android';
  else if (ua.includes('iOS') || ua.includes('iPhone') || ua.includes('iPad')) osName = 'iOS';
  
  return {
    browser: browserName,
    os: osName,
    userAgent: ua.substring(0, 200),
    language: navigator.language,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
};
